/* ==========================================================================
   Download all — one zip of a product's download files.
   Used by the Library card (snippets/cad-library-card.liquid, assets/cad-library.js)
   and the product page Downloads block (snippets/product-cad-files.liquid).

   Markup: <button data-cad-zip="url|url|url" data-cad-zip-name="30110-color-cap-pendant-files">
             ... <span data-cad-zip-label>Download all</span></button>
   The files live on cdn.shopify.com, which allows cross-origin fetches, so the browser builds the zip
   itself: nothing to upload or keep in sync. JSZip loads from cdnjs on the first click only.
   If the zip cannot be built, the files open one by one instead, so the visitor always gets them.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__dbCadZip) return;
  window.__dbCadZip = true;

  var JSZIP_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
  var jszipPromise = null;

  function loadJsZip() {
    if (window.JSZip) return Promise.resolve(window.JSZip);
    if (jszipPromise) return jszipPromise;
    jszipPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = JSZIP_SRC;
      s.async = true;
      s.onload = function () { window.JSZip ? resolve(window.JSZip) : reject(new Error('JSZip missing')); };
      s.onerror = function () { jszipPromise = null; reject(new Error('JSZip failed to load')); };
      document.head.appendChild(s);
    });
    return jszipPromise;
  }

  function fileName(url, used) {
    var name = 'file';
    try { name = decodeURIComponent(new URL(url, window.location.href).pathname.split('/').pop()) || 'file'; } catch (e) { /* keep default */ }
    var base = name, n = 2;
    while (used[name]) {
      var dot = base.lastIndexOf('.');
      name = dot > 0 ? base.slice(0, dot) + '-' + n + base.slice(dot) : base + '-' + n;
      n++;
    }
    used[name] = true;
    return name;
  }

  function saveBlob(blob, name) {
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = name;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
  }

  function openEach(urls) {
    urls.forEach(function (u) { window.open(u, '_blank', 'noopener'); });
  }

  function setLabel(btn, text) {
    var label = btn.querySelector('[data-cad-zip-label]');
    if (label) label.textContent = text;
  }

  function downloadAll(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var urls = (btn.getAttribute('data-cad-zip') || '').split('|').filter(Boolean);
    if (!urls.length) return;
    var name = (btn.getAttribute('data-cad-zip-name') || 'dutton-brown-files') + '.zip';

    btn.setAttribute('aria-busy', 'true');
    setLabel(btn, 'Preparing…');

    loadJsZip().then(function (JSZip) {
      var zip = new JSZip(), used = {};
      return Promise.all(urls.map(function (u) {
        return fetch(u, { mode: 'cors' }).then(function (res) {
          if (!res.ok) throw new Error(res.status + ' ' + u);
          return res.blob();
        }).then(function (blob) { zip.file(fileName(u, used), blob); });
      })).then(function () { return zip.generateAsync({ type: 'blob' }); });
    }).then(function (blob) {
      saveBlob(blob, name);
      setLabel(btn, 'Download all');
    }).catch(function () {
      // Popup blockers may stop all but the first; the visitor still sees each file's own box.
      openEach(urls);
      setLabel(btn, 'Download all');
    }).then(function () {
      btn.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-cad-zip]');
    if (btn) downloadAll(btn);
  });
})();
